import styled from 'styled-components';

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  [theme.breakpoint.media.max.sm]: {
    paddingInline: '24rem',
  },
}));

export const NotificationContainer = styled.div(() => ({
  marginBottom: '10rem',
  marginTop: '10rem',
}));
